<template>
    <div class="page-wrapper">
         <div class="searchBox">
           <div class="left">
                <!-- <el-form :inline="true">
                    <el-form-item>
                      <el-input placeholder="新闻标题" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-input placeholder="新闻类目" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item >
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form> -->
            </div>
            <div class="right">
                <el-button type="primary" @click="addNews">新增新闻</el-button>
            </div>
        </div> 
        <div class="tableBox" >
            <el-table v-loading="isLoading" :data="tableData">
                <el-table-column label="序号" width="70">
                    <template slot-scope="scope">{{ scope.$index + 1}}</template>
                </el-table-column>
                <!-- <el-table-column label="新闻ID">
                    <template slot-scope="scope">{{ scope.row.item_id }}</template>
                </el-table-column> -->
                <el-table-column label="新闻名称">
                    <template slot-scope="scope">
                        {{scope.row.title}}
                    </template>
                </el-table-column>
                <el-table-column label="类目" width="140">
                    <template slot-scope="scope">{{ scope.row.category }}</template>
                </el-table-column>
                <el-table-column label="摘要">
                    <template slot-scope="scope"> {{ scope.row.introduction }}</template>
                </el-table-column>
                <!-- <el-table-column label="状态" width="120">
                     <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.state == 1">已上架</el-tag>
                        <el-tag type="info" v-else>已下架</el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column label="发布时间" width="160">
                    <template slot-scope="scope"> {{ scope.row.displayTime || scope.row.createTime.slice(0,10) }}</template>
                </el-table-column>
                <el-table-column label="操作" width="240">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini" @click="toDetail(scope.row)">查看</el-button>
                        <el-button type="primary" plain size="mini" @click="toEdit(scope.row)">编辑</el-button>
                        <el-button type="danger" plain size="mini" @click="toDelete(scope.row)">删除</el-button>
                        <!-- <el-button type="danger" plain size="mini" v-if="scope.row.state == 1" @click="changeState(scope.row, scope.$index)">下架</el-button>
                        <el-button type="success" plain size="mini" v-else @click="changeState(scope.row, scope.$index)">上架</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {ajaxPost, api} from '@/common/request.js'
    import { utils} from '@/common/common.js'
    import { ajaxNews, NEWS_TYPE } from '@/common/request_news.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
              isLoading: false,
              searchObj: {
                page: 1,
                num: 10,
              },
              //表格
              tableData: [],
              //分页
              total: 0,
            }
        },
        computed: {
            function_viewGoodsDetail() {
              return utils.getCurrentFunction().indexOf("viewGoodsDetail")>-1
            },
            function_editGoods() {
              return utils.getCurrentFunction().indexOf("editGoods")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },
            adminId() {
                return utils.getAdminId()
            },
            token(){
              return utils.getToken()
            },
        },
        watch: {
            $route: {
                handler: function(route) {
                    this.searchObj.num = Number(this.$route.query.size) ? Number(this.$route.query.size) : 10;
                    this.searchObj.page = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1;
                    this.getNewsList();
                },
                immediate: true
            }
        },
        components: {

        },
        methods: {
          getNewsList() {
            this.isLoading = true
            ajaxNews.get('/api/news/page', {
              type: NEWS_TYPE,
              current: this.searchObj.page,
              size: this.searchObj.num,
            }).then(res => {
              console.log(res);
              if (res.code == 200) {
                this.total = parseInt(res.data.total);
                this.tableData = res.data.records
              } else {
                this.$message.error(res.msg || '获取列表信息失败');
              }
            }).finally(() => {
              this.isLoading = false
            })
          },
          addNews() {
            this.$router.push('/news/add')
          },
          toDetail(item) {
            this.$router.push('/news/detail?id=' + item.id)
          },
          toEdit(item) {
            this.$router.push('/news/edit?id=' + item.id)
          },
          toDelete(row, index) {
            this.$confirm('确定删除该条新闻吗？ （名称：' + row.title + '）', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
            }).then(() => {
							this.deleteNews(row, index)
            })
          },
					deleteNews(row, index) {
							ajaxNews.post('/api/news/remove?ids='+ row.id).then(res => {
									console.log(res)
									if (res.code == 200) {
											// this.tableData.splice(index, 1);
                      this.getNewsList();
											this.$message.success('删除成功');
									} else {
											this.$message.error(res.msg || '操作失败')
									}
							}).catch(err => {
									console.log(err)
							})
					},
					fuzzySearchClick() {
							this.searchObj.page = 1;
							this.updateRouter();
					},
					updateRouter() {
							this.$router.push(
									"/news/list?page=" + this.searchObj.page +
														"&size=" + this.searchObj.num
									)
					},
					handleSizeChange(size) { //分页：每页n条
							this.searchObj.num = size
							this.searchObj.page = 1
							this.updateRouter()
					},
					handleCurrentChange(page) { //分页：改变第n页
							this.searchObj.page = page
							this.updateRouter()
					},

					// 商品上下架
					changeState(row, index) {
							console.log(row, index)
							let confirmTip = row.state == 1 ? '下架' : '上架'
							this.$confirm(confirmTip + '该条新闻吗？ （名称：' + row.title + '）', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
							}).then(() => {
									this.updateItemState(row, index)
							}).catch(() => {
									this.$message({
											type: 'info',
											message: '已取消操作'
									})
							})
					},
					updateItemState(row, index) {
							let state = row.state == 1 ? 2 : 1   // 1 - 上架  2 - 下架
							ajaxNews.post('/api/news/update', {
									id: row.id,
									state: state
							}).then(res => {
									console.log(res)
									if (res.code == 200) {
											this.tableData[index].state = state
											let tip = state == 1 ? '上架成功' : '下架成功'
											this.$message.success(tip)
									} else {
											let errTip = state == 1 ? '上架失败' : '下架失败'
											this.$message.error(errTip)
									}
							}).catch(err => {
									console.log(err)
							})
					},
        },
        created() {
   
        },

        mounted() {

        }
    }
</script>

<style scoped lang="scss">
  .page-wrapper {
    background: #fff;
    padding: 16px;
  }
    .avatarImg{width: 60px;height:60px;}
    .searchBox {
        padding: 16px 16px 16px;
        border-bottom: 2px solid #f5f5f5;

        .left {
            float: left;
        }

        .right {
            float: right;
        }
    }

    .searchBox:after {
        content: "";
        display: block;
        clear: both;
    }

    .tableBox {
        padding: 0.25rem;
    }

</style>



// WEBPACK FOOTER //
// src/pages/news/list.vue